import { render, staticRenderFns } from "./messages-table.vue?vue&type=template&id=3ea6e828&scoped=true&"
import script from "./messages-table.vue?vue&type=script&lang=js&"
export * from "./messages-table.vue?vue&type=script&lang=js&"
import style0 from "./messages-table.vue?vue&type=style&index=0&id=3ea6e828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea6e828",
  null
  
)

export default component.exports